'use strict';

import filterItems from './filteritems.js';
import initContactForm from './contact-form.js';
import sliders from './sliders.js';

document.addEventListener('DOMContentLoaded', () => {
  /* Header stylings */
  // TO DO: Move this to PHP for better practice
  const siteHeader = document.querySelector('.site-header');
  const homeHero = document.querySelector('.home-hero');
  const productOverviewHero = document.querySelector(
    '.product-overview-hero'
  );
  const aboutHero = document.querySelector('.about-hero');
  const defaultHeroDark = document.querySelector(
    '.default-hero--dark'
  );
  const vacancies = document.querySelector('.vacancies-section');

  if (vacancies) {
    siteHeader.classList.add('site-header--primary');
  } else if (
    homeHero ||
    productOverviewHero ||
    aboutHero ||
    defaultHeroDark
  ) {
    siteHeader.classList.add('site-header--secondary');
  }

  if (document.getElementById('contact-wrapper')) {
    initContactForm();
  }

  /* USPs scrolling effect */
  const usps = document.querySelectorAll('.usps__item');

  if (usps) {
    for (const usp of usps) {
      window.addEventListener('scroll', () => {
        const uspPosition = usp.getBoundingClientRect();

        if (uspPosition.top - 100 < 0) {
          usp.classList.add('active');
        } else {
          usp.classList.remove('active');
        }
      });
    }
  }

  filterItems();
  sliders();
});
